import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/backgrounds/bg-mountains.svg")